// src/api/auth.ts
import { api } from './client';
import type { ApiResponse, LoginResponse, RegisterResponse, ProfileResponse, RoleUpdateResponse, GoogleLoginResponse } from '../types';

export const authAPI = {
  healthCheck: () => api.get<ApiResponse>('/api/auth/health-check'),
  
  register: (data: {
    email: string;
    password: string;
    fullName: string;
    phone?: string;
    role?: 'customer' | 'rider' | 'admin' | 'support';
  }) => api.post<ApiResponse<LoginResponse>>('/api/auth/register', data),
  
  login: (credentials: { email: string; password: string }) =>
    api.post<ApiResponse<LoginResponse>>('/api/auth/login', credentials),
  
  googleLogin: (data: { token: string; email?: string; name?: string; picture?: string }) =>
    api.post<ApiResponse<GoogleLoginResponse>>('/api/auth/google', data),
  
  googleToken: (data: { token: string; email: string; name?: string; picture?: string }) =>
    api.post<ApiResponse<GoogleLoginResponse>>('/api/auth/google/token', data),
  
  getProfile: () => api.get<ApiResponse<ProfileResponse>>('/api/auth/me'),
  
  updateRole: (role: 'customer' | 'rider') =>
    api.put<ApiResponse<RoleUpdateResponse>>('/api/auth/update-role', { role }),
  
  // Password management endpoints
  forgotPassword: (data: { email: string }) =>
    api.post<ApiResponse>('/api/auth/forgot-password', data),
  
  resetPassword: (data: { token: string; password: string }) =>
    api.post<ApiResponse>('/api/auth/reset-password', data),
  
  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    api.post<ApiResponse>('/api/auth/change-password', data),
  
  // Email verification endpoints
  verifyEmail: (token: string) =>
    api.get<ApiResponse>(`/api/auth/verify-email/${token}`),
  
  resendVerification: (email: string) =>
    api.post<ApiResponse>('/api/auth/resend-verification', { email }),
  
  refreshToken: () =>
    api.post<ApiResponse<{ token: string }>>('/api/auth/refresh-token'),
};

export default authAPI;